var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: { size: "auto", title: "Unmatch Agent" },
      model: {
        value: _vm.unmatchAnAgent.visible,
        callback: function($$v) {
          _vm.$set(_vm.unmatchAnAgent, "visible", $$v)
        },
        expression: "unmatchAnAgent.visible"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "unmatch-agent-modal",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          !_vm.prevAgentName
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("q-spinner-puff", {
                    attrs: { color: "primary", size: "60px" }
                  })
                ],
                1
              )
            : _c("div", { staticClass: "row gutter-sm" }, [
                _vm.isTimeLeft
                  ? _c("div", { staticClass: "col-auto" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.prevAgentName) +
                          " will be unmatched from this tour, and we'll be\n        back to searching for other agents."
                      ),
                      _c("br"),
                      _vm._v(
                        "\n        There are " +
                          _vm._s(_vm.minutesUntilCutoff) +
                          " minutes left until the timeout to find an agent.\n      "
                      )
                    ])
                  : _c("div", { staticClass: "col-auto" }, [
                      _vm._v(
                        "\n        As there's no time to look for a new agent, " +
                          _vm._s(_vm.prevAgentName) +
                          " will be\n        unmatched from this tour, and this tour will be cancelled."
                      ),
                      _c("br"),
                      _vm._v(
                        "\n        The lead will be notified and prompted to schedule a different time.\n      "
                      )
                    ]),
                _c(
                  "div",
                  { staticClass: "text-right col-12", attrs: { center: "" } },
                  [
                    _c(
                      "span",
                      { staticClass: "button" },
                      [
                        _c("q-btn", {
                          attrs: { padding: "", outline: "", label: "cancel" },
                          on: { click: _vm.closeModal }
                        })
                      ],
                      1
                    ),
                    _vm.isTimeLeft
                      ? _c(
                          "span",
                          [
                            _c("q-btn", {
                              attrs: {
                                padding: "",
                                outline: "",
                                label: "Unmatch agent"
                              },
                              on: { click: _vm.submitUnmatchAnAgent }
                            })
                          ],
                          1
                        )
                      : _c(
                          "span",
                          [
                            _c("q-btn", {
                              attrs: {
                                padding: "",
                                outline: "",
                                label: "Unmatch agent and cancel tour"
                              },
                              on: { click: _vm.submitUnmatchAnAgent }
                            })
                          ],
                          1
                        )
                  ]
                )
              ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }